import React, { ReactNode } from 'react'

import {
  Box,
  Skeleton,
  TableCell as MuiTableCell,
  TableCellProps as MuiTableCellProps,
  useTheme,
} from '@mui/material'
import { get, isFunction } from 'lodash'

// -------------------------------------------------------------------

// TODO: Fix Fonts
// ...(stsize === 'xs'
//   ? theme.typography[bold ? 'subtitle4' : 'body4']
//   : stsize === 'sm'
//   ? theme.typography[bold ? 'subtitle3' : 'body3']
//   : theme.typography[bold ? 'subtitle2' : 'body2']),

type TableCellProps = Omit<MuiTableCellProps, 'size'> & {
  bold?: boolean
  noWrap?: boolean
  noBorder?: boolean
  size?: 'xs' | 'sm' | 'md' | 'lg'
  isLoading?: boolean
  children?: ReactNode
}

const TableCell: React.FC<TableCellProps> = ({
  isLoading,
  children,
  size,
  color,
  bold,
  noWrap,
  noBorder,
  onClick,
  sx,
  ...rest
}) => {
  const theme = useTheme()

  const combinedSx = {
    ...(isFunction(onClick) && {
      cursor: 'pointer',
      color: theme.palette.primary.main,
    }),
    ...((size === 'sm' || size === 'xs') && {
      padding: theme.spacing(1),
    }),
    ...(color && { color: get(theme.palette, color) }),
    ...(bold && { fontWeight: 'bold' }),
    ...(noWrap && { whiteSpace: 'nowrap' }),
    ...(noBorder && { border: 'none' }),
    ...(typeof sx === 'function' ? sx(theme) : sx),
  }

  if (isLoading)
    return (
      <MuiTableCell {...rest} onClick={onClick} sx={combinedSx}>
        <Skeleton>
          <Box>{children}</Box>
        </Skeleton>
      </MuiTableCell>
    )

  return (
    <MuiTableCell {...rest} onClick={onClick} sx={combinedSx}>
      {children}
    </MuiTableCell>
  )
}

export const SmallTableCell = (props: TableCellProps) => <TableCell {...props} size={'sm'} />
export const ExtraSmallTableCell = (props: TableCellProps) => <TableCell {...props} size={'xs'} />

export default TableCell
